module.exports = __webpack_public_path__ + "img/DSC_2851-xl.40f734a8.png";